import camelcaseKeys from 'camelcase-keys';

import { formatToRequestParameter } from 'utils/formatting';
import apiGateway from '../axios';
import {
  IGetSurvey,
  IGetSearchSurvey,
  ICreateHospitalization,
  ICreateOutHospital,
  IUpdateMedication,
  IUpdateFall,
  IUpdateFallTwo,
  IUpdatePediatric_fall,
  IUpdateGCS,
  IUpdatePediatric_GCS,
  IUpdateFourScore,
  IUpdateBedScore,
  IUpdateNeeds,
  IUpdateClinicObservation,
  IUpdateTakingOver,
  IUpdateECardex,
  IUpdateGlucose,
  IUpdateSafety,
  IUpdateCNPS,
  IUpdateFLACC,
  IUpdateNRS,
  IUpdateMentalNursing,
  IUpdateBDI,
  IUpdateBAI,
  IUpdateMMSE,
  IUpdateCIST,
  IUpdateOperation,
  IUpdateAnesthesia,
  IUpdateTransfusion,
  IUpdateCPR,
  IUpdateDialysis,
  IUpdateEmergency,
  IUpdateChildbirth,
  IUpdateHomeCare,
  IUpdateDietNutrition,
  IUpdateKPCS,
  IUpdateDietList,
  IUpdateHospitalConfirm,
  IUpdateFallConfirm,
  IUpdateColonoscopy,
  IUpdateUpperEndoscopy,
  IUpdateSuppressor,
  IUpdateNonSalary,
  IUpdateMedicalRecords,
  IUpdateDNR,
  IUpdateDNA,
  IUpdateTransfusionAgree,
  IUpdateCheckListRoom,
  IUpdateFFI,
  IUpdateKOOS,
  IUpdateLEFS,
  IUpdateNDI,
  IUpdateSTarTBack,
  IUpdateCRRT,
  IUpdateCentralVenous,
  IUpdateNursingProcess,
  IUpdateKPCS_ICU,
  IUpdateIntubation,
  IUpdateDNRTwo,
  IUpdateKPCSC,
  IUpdateKPCSN,
  IUpdateKPCS_GW,
  IUpdateKPCS_NICU,
  IUpdateKDSQ_P,
  IUpdateKDSQ_C,
  IUpdateK_CPAT,
  IUpdatePAINAD_K,
  IUpdatePAINAD_K_none,
  IUpdateClinicObservationICU,
  IIORCheckCord,
  IUpdateIntubationAgree,
  IUpdateFallThree,
  IUpdateMSE,
  IBloodDispensing,
  IUpdateNEWS2,
  IUpdateBedScoreFour,
  IUpdateBedScoreThree,
  IUpdateSBAR,
  IUpdateSBAR2,
  IUpdateSBAR3,
  IUpdateNursingNeed,
  IUpdateAdmissionAndDischarge,
  IUpdateSelfDischarge,
  IInfection,
  IUpdateRestraint,
  IPersonalAgreement,
  ISimulActivityPlan,
  IProcessRecord,
  IBloodBarcode,
  IDebriefing,
  IUpdateMinor,
  IUpdateEcmoRecord,
  IConsentForSurgery,
  IUpdateMaturity,
} from './type';

// e-CARDEX
export const getECardex = (request: IGetSurvey) => {
  const url = `/survey/ecardex?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateECardex = (request: IUpdateECardex) => {
  const url = `/survey/ecardex`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 간호인수인계
export const getTakingOver = (request: IGetSurvey) => {
  const url = `/survey/takeover?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateTakingOver = (request: IUpdateTakingOver) => {
  const url = `/survey/takeover`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// SBAR
export const getSBAR = (request: IGetSurvey) => {
  const url = `/survey/sbar1?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSBAR = (request: IUpdateSBAR) => {
  const url = `/survey/sbar1`;
  return apiGateway.post(url, request);
};

// SBAR2
export const getSBAR2 = (request: IGetSurvey) => {
  const url = `/survey/sbar2?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSBAR2 = (request: IUpdateSBAR2) => {
  const url = `/survey/sbar2`;
  return apiGateway.post(url, request);
};

// SBAR3
export const getSBAR3 = (request: IGetSurvey) => {
  const url = `/survey/sbar3?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSBAR3 = (request: IUpdateSBAR3) => {
  const url = `/survey/sbar3`;
  return apiGateway.post(url, request);
};

// 입원간호기록지
export const getHospitalization = (request: IGetSurvey) => {
  const url = `/survey/hospital?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const createHospitalization = (request: ICreateHospitalization) => {
  const url = `/survey/hospital`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 퇴원간호기록지
export const getOutHospital = (request: IGetSurvey) => {
  const url = `/survey/out/hospital?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const createOutHospital = (request: ICreateOutHospital) => {
  const url = `/survey/out/hospital`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 환자상황 및 처방내역
export const getMedication = (request: IGetSurvey) => {
  const url = `/survey/medication?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateMedication = (request: IUpdateMedication) => {
  const url = `/survey/medication`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 영상검사기록지
export const getRadiology = (request: IGetSurvey) => {
  const url = `/survey/radiology?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

// 기타 기록지
export const getEtcRecord = (request: IGetSurvey) => {
  const url = `/survey/miscellaneous?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

// 임상병리검사기록지
export const getPathology = (request: IGetSurvey) => {
  const url = `/survey/pathology?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

// 임상관찰기록지
export const getClinicObservation = (request: IGetSurvey) => {
  const url = `/survey/clinicObservation?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateClinicObservation = (request: IUpdateClinicObservation) => {
  const url = `/survey/clinicObservation`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 임상관찰기록지ICU
export const getClinicObservationICU = (request: IGetSurvey) => {
  const url = `/enr_etc/catholic/clinical_observation?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateClinicObservationICU = (
  request: IUpdateClinicObservationICU
) => {
  const url = `/enr_etc/catholic/clinical_observation`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 혈당기록지
export const getGlucose = (request: IGetSurvey) => {
  const url = `/survey/bloodSugar?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateGlucose = (request: IUpdateGlucose) => {
  const url = `/survey/bloodSugar`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 섭취 배설량 기록지
export const getIntakeOutput = (request: IGetSurvey) => {
  const url = `/survey/intake_output?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updatIntakeOutput = (request: IIORCheckCord) => {
  const url = `/survey/intake_output`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// NEWS2
export const getNews2 = (request: IGetSurvey) => {
  const url = `/survey/news2?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateNews2 = (request: IUpdateNEWS2) => {
  const url = `/survey/news2`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 욕창위험도평가도구
export const getBedScore = (request: IGetSurvey) => {
  const url = `/survey/bedsore?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateBedScore = (request: IUpdateBedScore) => {
  const url = `/survey/bedsore`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 욕창위험도평가도구2
export const getBedScoreTwo = (request: IGetSurvey) => {
  const url = `/survey/bedsore2?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateBedScoreTwo = (request: IUpdateBedScore) => {
  const url = `/survey/bedsore2`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 욕창위험도평가도구3
export const getBedScoreThree = (request: IGetSurvey) => {
  const url = `/survey/bedsore3?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateBedScoreThree = (request: IUpdateBedScoreThree) => {
  const url = `/survey/bedsore3`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 욕창 평가도구 4
export const getBedSoreFour = (request: IGetSurvey) => {
  const url = `/survey/bedsore4?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateBedSoreFour = (request: IUpdateBedScoreFour) => {
  const url = `/survey/bedsore4`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 욕구평가기록지
export const getNeeds = (request: IGetSurvey) => {
  const url = `/survey/needs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateNeeds = (request: IUpdateNeeds) => {
  const url = `/survey/needs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 낙상위험도평가도구 I
export const getFall = (request: IGetSurvey) => {
  const url = `/survey/fall?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateFall = (request: IUpdateFall) => {
  const url = `/survey/fall`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 낙상위험 평가도구 2
export const getFallTwo = (request: IGetSurvey) => {
  const url = `/survey/fall2?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateFallTwo = (request: IUpdateFallTwo) => {
  const url = `/survey/fall2`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 낙상위험 평가도구 3
export const getFallThree = (request: IGetSurvey) => {
  const url = `/survey/fall3?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateFallThree = (request: IUpdateFallThree) => {
  const url = `/survey/fall3`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 소아 낙상위험 평가
export const getPediatric_fall = (request: IGetSurvey) => {
  const url = `/survey/pediatric_fall?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updatePediatric_fall = (request: IUpdatePediatric_fall) => {
  const url = `/survey/pediatric_fall`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// GCS
export const getGCS = (request: IGetSurvey) => {
  const url = `/survey/gcs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateGCS = (request: IUpdateGCS) => {
  const url = `/survey/gcs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// Pediatric_GCS
export const getPediatric_GCS = (request: IGetSurvey) => {
  const url = `/survey/pediatric_gcs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updatePediatric_GCS = (request: IUpdatePediatric_GCS) => {
  const url = `/survey/pediatric_gcs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// Four Score
export const getFourScore = (request: IGetSurvey) => {
  const url = `/survey/FOUR_Score?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateFourScore = (request: IUpdateFourScore) => {
  const url = `/survey/FOUR_Score`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 고위험 신생아의 성숙도 사정
export const getMaturity = (request: IGetSurvey) => {
  const url = `/survey/new_ballard_scale?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateMaturity = (request: IUpdateMaturity) => {
  const url = `/survey/new_ballard_scale`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 환자안전사고보고서
export const getSafety = (request: IGetSurvey) => {
  const url = `/survey/safety?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSafety = (request: IUpdateSafety) => {
  const url = `/survey/safety`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 감염노출 보고서
export const getInfection = (request: IGetSurvey) => {
  const url = `/survey/infection?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateInfection = (request: IInfection) => {
  const url = `/survey/infection`;
  return apiGateway.post(url, request);
};

// NRS
export const getNRS = (request: IGetSurvey) => {
  const url = `/survey/nrs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateNRS = (request: IUpdateNRS) => {
  const url = `/survey/nrs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// FLACC
export const getFLACC = (request: IGetSurvey) => {
  const url = `/survey/flacc?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateFLACC = (request: IUpdateFLACC) => {
  const url = `/survey/flacc`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// CNPS
export const getCNPS = (request: IGetSurvey) => {
  const url = `/survey/cnps?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateCNPS = (request: IUpdateCNPS) => {
  const url = `/survey/cnps`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 ( FFI )
export const getFFI = (request: IGetSurvey) => {
  const url = `survey/ffi?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateFFI = (request: IUpdateFFI) => {
  const url = `survey/ffi`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 ( KOOS )
export const getKOOS = (request: IGetSurvey) => {
  const url = `/survey/koos?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKOOS = (request: IUpdateKOOS) => {
  const url = `/survey/koos`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 ( LEFS )
export const getLEFS = (request: IGetSurvey) => {
  const url = `/survey/lefs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateLEFS = (request: IUpdateLEFS) => {
  const url = `/survey/lefs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 ( NDI )
export const getNDI = (request: IGetSurvey) => {
  const url = `/survey/ndi?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateNDI = (request: IUpdateNDI) => {
  const url = `/survey/ndi`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 (STarT Back)
export const getSTarT = (request: IGetSurvey) => {
  const url = `/survey/start_back?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSTarT = (request: IUpdateSTarTBack) => {
  const url = `/survey/start_back`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 (K_CPAT)
export const getK_CPAT = (request: IGetSurvey) => {
  const url = `/survey/kcpat?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateK_CPAT = (request: IUpdateK_CPAT) => {
  const url = `/survey/kcpat`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 (PAINAD_K)
export const getPAINAD_K = (request: IGetSurvey) => {
  const url = `/survey/painadk_communicative?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updatePAINAD_K = (request: IUpdatePAINAD_K) => {
  const url = `/survey/painadk_communicative`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 통증 (PAINAD_K_none)
export const getPAINAD_K_none = (request: IGetSurvey) => {
  const url = `/survey/painadk_noncommunicative?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updatePAINAD_K_none = (request: IUpdatePAINAD_K_none) => {
  const url = `/survey/painadk_noncommunicative`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 정신간호 기록지
export const getMentalNursing = (request: IGetSurvey) => {
  const url = `/survey/mental?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateMentalNursing = (request: IUpdateMentalNursing) => {
  const url = `/survey/mental`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// MSE
export const getMSE = (request: IGetSurvey) => {
  const url = `/survey/mse?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const createMSE = (request: IUpdateMSE) => {
  const url = `/survey/mse`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// BDI
export const getBDI = (request: IGetSurvey) => {
  const url = `/survey/bdi?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateBDI = (request: IUpdateBDI) => {
  const url = `/survey/bdi`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// BAI
export const getBAI = (request: IGetSurvey) => {
  const url = `/survey/bai?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateBAI = (request: IUpdateBAI) => {
  const url = `/survey/bai`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// MMSE
export const getMMSE = (request: IGetSurvey) => {
  const url = `/survey/mmse?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateMMSE = (request: IUpdateMMSE) => {
  const url = `/survey/mmse`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// CIST IUpdate
export const getCIST = (request: IGetSurvey) => {
  const url = `/survey/cist?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateCIST = (request: IUpdateCIST) => {
  const url = `/survey/cist`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KDSQ_P
export const getKDSQ_P = (request: IGetSurvey) => {
  const url = `/survey/kdsqp?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKDSQ_P = (request: IUpdateKDSQ_P) => {
  const url = `/survey/kdsqp`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KDSQ_C
export const getKDSQ_C = (request: IGetSurvey) => {
  const url = `/survey/kdsqc?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKDSQ_C = (request: IUpdateKDSQ_C) => {
  const url = `/survey/kdsqc`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 수술기록지
export const getOperation = (request: IGetSurvey) => {
  const url = `/survey/surgical?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateOperation = (request: IUpdateOperation) => {
  const url = `/survey/surgical`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 마취 기록지
export const getAnesthesia = (request: IGetSurvey) => {
  const url = `/survey/anesthetic?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateAnestheia = (request: IUpdateAnesthesia) => {
  const url = `/survey/anesthetic`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 혈액불출요청서
export const getBloodDispensing = (request: IGetSurvey) => {
  const url = `/survey/blood_dispensing?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateBloodDispensing = (request: IBloodDispensing) => {
  const url = `/survey/blood_dispensing`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 수혈기록지
export const getTransfusion = (request: IGetSurvey) => {
  const url = `/survey/transfusion?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateTransfusion = (request: IUpdateTransfusion) => {
  const url = `/survey/transfusion`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 수혈기록지 바코드 GET
export const getBloodBarcode = (request: IBloodBarcode) => {
  const url = `/main/get_transfusion_barcode?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

// 신체보호대 기록지
export const getRestraint = (request: IGetSurvey) => {
  const url = `/survey/medical_restraint?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const createRestraint = (request: IUpdateRestraint) => {
  const url = `/survey/medical_restraint`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// CPR 기록지
export const getCPR = (request: IGetSurvey) => {
  const url = `/enr_etc/catholic/cpr?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateCPR = (request: IUpdateCPR) => {
  const url = `/enr_etc/catholic/cpr`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 투석기록지
export const getDialysis = (request: IGetSurvey) => {
  const url = `/survey/hemodialysis?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateDialysis = (request: IUpdateDialysis) => {
  const url = `/survey/hemodialysis`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 삽관 기록지
export const getIntubation = (request: IGetSurvey) => {
  const url = `/survey/line?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateIntubation = (request: IUpdateIntubation) => {
  const url = `/survey/line`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 응급기록지
export const getEmergency = (request: IGetSurvey) => {
  const url = `/survey/emergency?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateEmergency = (request: IUpdateEmergency) => {
  const url = `/survey/emergency`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 분만기록지
export const getChildbirth = (request: IGetSurvey) => {
  const url = `/survey/delivery?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateChildbirth = (request: IUpdateChildbirth) => {
  const url = `/survey/delivery`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 가정간호 기록지
export const getHomeCare = (request: IGetSurvey) => {
  const url = `/survey/homecare?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateHomeCare = (request: IUpdateHomeCare) => {
  const url = `/survey/homecare`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// ECMO 기록지
export const getECMO = (request: IGetSurvey) => {
  const url = `/survey/ecmo?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateECMO = (request: IUpdateEcmoRecord) => {
  const url = `/survey/ecmo`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KPCS
export const getKPCS = (request: IGetSurvey) => {
  const url = `/survey/kpcs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKPCS = (request: IUpdateKPCS) => {
  const url = `/survey/kpcs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KPCSC
export const getKPCSC = (request: IGetSurvey) => {
  const url = `/survey/kpcsc?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKPCSC = (request: IUpdateKPCSC) => {
  const url = `/survey/kpcsc`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KPCSN
export const getKPCSN = (request: IGetSurvey) => {
  const url = `/survey/kpcs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKPCSN = (request: IUpdateKPCSN) => {
  const url = `/survey/kpcs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KPCS_GW
export const getKPCS_GW = (request: IGetSurvey) => {
  const url = `/survey/kpcs_gw?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKPCS_GW = (request: IUpdateKPCS_GW) => {
  const url = `/survey/kpcs_gw`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KPCS_ICU
export const getKPCS_ICU = (request: IGetSurvey) => {
  const url = `/survey/kpcs_icu?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKPCS_ICU = (request: IUpdateKPCS_ICU) => {
  const url = `/survey/kpcs_icu`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KPCS_NICU
export const getKPCS_NICU = (request: IGetSurvey) => {
  const url = `/survey/kpcs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateKPCS_NICU = (request: IUpdateKPCS_NICU) => {
  const url = `/survey/kpcs`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// KPCS_NICU
export const getNursingNeed = (request: IGetSurvey) => {
  const url = `/survey/nursing_needs?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateNursingNeed = (request: IUpdateNursingNeed) => {
  const url = `/survey/nursing_needs`;
  return apiGateway.post(url, request);
};

// 식이/영양 기록지
export const getDietList = (request: IGetSurvey) => {
  const url = `/survey/dietary?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateDietList = (request: IUpdateDietList) => {
  const url = `/survey/dietary`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// // 식이/영양 기록지
// export const getDietNutrition = (request: IGetSurvey) => {
//   const url = `/survey/dietary?${formatToRequestParameter(request)}`;
//   return apiGateway.get(url);
// };

// export const updateDietNutrition = (request: IUpdateDietNutrition) => {
//   const url = `/survey/dietary`;
//   return apiGateway.post(url, camelcaseKeys(request));
// };

// 입원안내확인서
export const getHospitalConfirm = (request: IGetSurvey) => {
  const url = `/survey/hospitalConfirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateHospitalConfirm = (request: IUpdateHospitalConfirm) => {
  const url = `/survey/hospitalConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 입퇴원동의서
export const getAdmAndDischarge = (request: IGetSurvey) => {
  const url = `/survey/adm_discharge?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateAdmAndDischarge = (
  request: IUpdateAdmissionAndDischarge
) => {
  const url = `/survey/adm_discharge`;
  return apiGateway.post(url, request);
};

// 자의퇴원서
export const getSelfDischarge = (request: IGetSurvey) => {
  const url = `/survey/self_discharge?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSelfDischarge = (request: IUpdateSelfDischarge) => {
  const url = `/survey/self_discharge`;
  return apiGateway.post(url, request);
};

// 낙상예방교육확인서
export const getFallConfirm = (request: IGetSurvey) => {
  const url = `/survey/fallConfirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateFallConfirm = (request: IUpdateFallConfirm) => {
  const url = `/survey/fallConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 수혈 동의서
export const getTransfusionAgree = (request: IGetSurvey) => {
  const url = `/survey/transfusion_confirm?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateTransfusionAgree = (request: IUpdateTransfusionAgree) => {
  const url = `/survey/transfusion_confirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 기관삽관 동의서
export const getIntubationAgree = (request: IGetSurvey) => {
  const url = `/survey/intubation_confirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateIntubationAgree = (request: IUpdateIntubationAgree) => {
  const url = `/survey/intubation_confirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 중심정맥삽관동의서
export const getCentralVenous = (request: IGetSurvey) => {
  const url = `/survey/cvc_insertion_confirm?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateCentralVenous = (request: IUpdateCentralVenous) => {
  const url = `/survey/cvc_insertion_confirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// CRRT
export const getCRRT = (request: IGetSurvey) => {
  const url = `/survey/crrt_confirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateCRRT = (request: IUpdateCRRT) => {
  const url = `/survey/crrt_confirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 대장 내시경
export const getColonoscopy = (request: IGetSurvey) => {
  const url = `/survey/colonoScopyConfirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateColonoscopy = (request: IUpdateColonoscopy) => {
  const url = `/survey/colonoScopyConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 상부내시경
export const getUpperEndoscopy = (request: IGetSurvey) => {
  const url = `/survey/upperEndoScopyConfirm?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateUpperEndoscopy = (request: IUpdateUpperEndoscopy) => {
  const url = `/survey/upperEndoScopyConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 억제대 동의서
export const getSuppressor = (request: IGetSurvey) => {
  const url = `/survey/restraints_confirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSuppressor = (request: IUpdateSuppressor) => {
  const url = `/survey/restraints_confirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 비급여확인서
export const getNonSalary = (request: IGetSurvey) => {
  const url = `/survey/uninsuredBenefitConfirm?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateNonSalary = (request: IUpdateNonSalary) => {
  const url = `/survey/uninsuredBenefitConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 수술동의서
export const getConsentForSurgery = (request: IGetSurvey) => {
  const url = `/survey/surgery_agreement?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateConsentForSurgery = (request: IConsentForSurgery) => {
  const url = `/survey/surgery_agreement`;
  return apiGateway.post(url, request);
};

// 진료 기록
export const getMedicalRecords = (request: IGetSurvey) => {
  const url = `/survey/chartConfirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateMedicalRecords = (request: IUpdateMedicalRecords) => {
  const url = `/survey/chartConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// DNR
export const getDNR = (request: IGetSurvey) => {
  const url = `/survey/advanceDirectiveConfirm?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateDNR = (request: IUpdateDNR) => {
  const url = `/survey/advanceDirectiveConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// DNRTwo
export const getDNRTwo = (request: IGetSurvey) => {
  const url = `/survey/dnr_confirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateDNRTwo = (request: IUpdateDNRTwo) => {
  const url = `/survey/dnr_confirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// DNA
export const getDNA = (request: IGetSurvey) => {
  const url = `/survey/geneTestConfirm?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateDNA = (request: IUpdateDNA) => {
  const url = `/survey/geneTestConfirm`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 미성년자시술동의서
export const getMinor = (request: IGetSurvey) => {
  const url = `/survey/minor_consent?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateMinor = (request: IUpdateMinor) => {
  const url = `/survey/minor_consent`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 간호체크리스트 ( 병동 )
export const getCheckListRoom = (request: IGetSurvey) => {
  const url = `/survey/nursing_check_list_ward?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateCheckListRoom = (request: IUpdateCheckListRoom) => {
  const url = `/survey/nursing_check_list_ward`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 과제 제출 확인 페이지 - 과제 조회
export const getAssignment = (params: any) => {
  // Default values
  const {
    user_id,
    patient_id,
    keyword = '',
    searchType,
    sort_method,
    class_section_id = -1,
    size = 20,
    page,
  } = params;

  const queryParams: string[] = [
    `user_id=${user_id}`,
    `patient_id=${patient_id}`,
    `class_section_id=${class_section_id}`,
    `size=${size}`,
    `page=${page}`,
  ];

  if (searchType !== undefined) {
    queryParams.push(`searchType=${searchType}`);
  }

  if (keyword) {
    queryParams.push(`keyword=${encodeURIComponent(keyword)}`);
  }

  if (sort_method !== undefined) {
    queryParams.push(`sort_method=${sort_method}`);
  }

  const url = `/main/search_assignment?${queryParams.join('&')}`;

  return apiGateway.get(url);
};

// 핵심간호술기 영상관리 페이지
export const getSkillVideo = (params: any) => {
  // Default values
  const {
    user_id,
    patient_id,
    keyword = '',
    searchType,
    sort_method,
    class_section_id = -1,
    size = 20,
    page,
  } = params;

  const queryParams: string[] = [
    `user_id=${user_id}`,
    `patient_id=${patient_id}`,
    `class_section_id=${class_section_id}`,
    `size=${size}`,
    `page=${page}`,
  ];

  if (searchType !== undefined) {
    queryParams.push(`searchType=${searchType}`);
  }

  if (keyword) {
    queryParams.push(`keyword=${encodeURIComponent(keyword)}`);
  }

  if (sort_method !== undefined) {
    queryParams.push(`sort_method=${sort_method}`);
  }

  const url = `/main/search_video?${queryParams.join('&')}`;

  return apiGateway.get(url);
};

// 간호기록 전체조회 페이지
export const getNursingRecode = (params: any) => {
  const {
    user_id,
    patient_id,
    keyword = '',
    searchType,
    sort_method = 1,
    class_section_id = -1,
    size = 20,
    page,
    start_date,
    end_date,
  } = params;

  const queryParams: string[] = [
    `user_id=${user_id}`,
    `patient_id=${patient_id}`,
    `class_section_id=${class_section_id}`,
    `size=${size}`,
    `page=${page}`,
  ];

  if (searchType !== undefined) {
    queryParams.push(`searchType=${searchType}`);
  }

  if (keyword) {
    queryParams.push(`keyword=${encodeURIComponent(keyword)}`);
  }

  if (sort_method !== undefined) {
    queryParams.push(`sort_method=${sort_method}`);
  }

  if (start_date) {
    queryParams.push(`start_date=${start_date}`);
  }

  if (end_date) {
    queryParams.push(`end_date=${end_date}`);
  }

  const url = `/main/search_nursing_record?${queryParams.join('&')}`;

  return apiGateway.get(url);
};

// 간호과정기록지
export const getNursingProcess = (request: IGetSurvey) => {
  const url = `/survey/nursing_process_narrative_note?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const updateNursingProcess = (request: IUpdateNursingProcess) => {
  const url = `/survey/nursing_process_narrative_note`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 간호과정기록지 전체조회 페이지
export const getNursingProcessAll = (request: IGetSearchSurvey) => {
  const { year, sort_method } = request;

  const baseUrl = () => {
    if (sort_method && year)
      return '/main/inquiry_nursing_process_narrative_note?';
    return '/main/inquiry_nursing_process_narrative_note?';
  };

  const url = `${baseUrl()}size=5&${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

// 활동계획서
export const getSimulationPlan = (request: IGetSearchSurvey) => {
  const url = `/survey/simulation_plan?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSimulationPlan = (request: ISimulActivityPlan) => {
  const url = `/survey/simulation_plan`;
  return apiGateway.post(url, request);
};

// 개인정보 수집 동의서
export const getPiiAgreement = (request: IGetSearchSurvey) => {
  const url = `/survey/pii_agreement?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updatePiiAgreement = (request: IPersonalAgreement) => {
  const url = `/survey/pii_agreement`;
  return apiGateway.post(url, request);
};

// 간호과정 기록지
export const getSimulationRecord = (request: IGetSearchSurvey) => {
  const url = `/survey/simulation_record?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateSimulationRecord = (request: IProcessRecord) => {
  const url = `/survey/simulation_record`;
  return apiGateway.post(url, request);
};

// 디브리핑
export const getDebriefing = (request: IGetSurvey) => {
  const url = `/survey/debriefing?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const updateDebriefing = (request: IDebriefing) => {
  const url = `/survey/debriefing`;
  return apiGateway.post(url, request);
};
